import { GetOrganisationQuery } from '../__generated__/organisation.generated';
import { MemberTableProps, MembersTable } from '../../../components/MembersTable';

export type OrganisationMemberDataType =
	GetOrganisationQuery['organisation']['members'][0]['user'] & {
		organisationRole: GetOrganisationQuery['organisation']['members'][0]['role'];
		memberId: GetOrganisationQuery['organisation']['members'][0]['id'];
	};

export const OrganisationMembersTable = ({
	data,
	columnsConfig,
	renderRowActions,
}: MemberTableProps<OrganisationMemberDataType>) => (
	<MembersTable data={data} columnsConfig={columnsConfig} renderRowActions={renderRowActions} />
);
